import { SurveyEvents } from 'src/shared/constants/surveys';
export const dispatchSaveCustomEvent = ({ moduleId, isUpdate, isExtraModule }) => {
    /*
     * NOTE: This event will be listened to by the app-club-admin so that after saving content
     * the listing is updated, the screen scrolls to the edited content and a survicate search is triggered.
     */
    window.dispatchEvent(new CustomEvent('app-content-admin:content:saved', {
        detail: {
            moduleId,
            isExtraModule,
            isModuleUpdate: true,
            ...(isUpdate ? {} : { surveyEvent: SurveyEvents.CreateContent })
        }
    }));
};
